const MenuActions = {
    FEATURE_TOGGLE_ACTION: "featureToggleAction",
    ROUTE_ACTION: "route",
};

export default MenuActions;
